/* eslint-disable no-unused-vars */
import { type SortDirection } from 'types/enums'

export enum ViewLikesContextActionType {
    SET_SEARCH_TERM = 'SET_SEARCH_TERM',
    SET_SORT_DIRECTION = 'SET_SORT_DIRECTION'
}

interface Actions {
    changeSortDirection: (currSortDirection: SortDirection) => void
    setSearchTerm: (text: string) => void
}

export interface IViewLikesContextState extends Actions {
    postId: string
    searchTerm: string
    sortDirection: SortDirection
}
